import { useQuery } from '@tanstack/react-query';
import type { ExternalToolDto } from '@inference.engine/api-client/web';
import { getExternalTools } from '../api';
import { EXTERNAL_TOOLS_QUERY_KEY } from './queryKeys';

const STALE_TIME = 5 * 60 * 1000; // 5 minutes

interface UseExternalToolsOptions {
  initialData?: ExternalToolDto[];
  workspaceId?: string;
  enabled?: boolean;
}

export const useGetExternalTools = (options: UseExternalToolsOptions = {}) => {
  const { initialData, workspaceId, enabled = true } = options;

  return useQuery({
    queryKey: [EXTERNAL_TOOLS_QUERY_KEY, workspaceId],
    queryFn: () => getExternalTools(workspaceId),
    staleTime: STALE_TIME,
    enabled,
    // Return undefined to fetch from API if initialData is not provided or empty
    initialData: initialData && initialData.length > 0 ? initialData : undefined,
  });
};
